import * as React from 'react';
export const nyceSvg = React.forwardRef(function nyceSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#ED1A2B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.51 19.454c-1.404 0-2.815-1.704-2.288-3.806.434-1.728 1.025-3.184 2.839-3.648h2.331c1.085.385 1.543 1.455 1.418 2.797h-1.856c.004-.724-.288-1.229-.932-1.229-.892 0-1.513.931-1.801 2.08-.289 1.149.051 2.08.758 2.08.908 0 1.33-.504 1.604-1.228h1.86c-.476 1.692-1.167 2.954-3.933 2.954ZM8.855 12l-.926 3.899L6.603 12H4.665L3 19.084h2.038l.883-3.878 1.24 3.878h1.981L10.865 12h-2.01Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.662 12h-2.337l-1.555 2.4-.625-2.4h-2.223l1.427 4.48-.595 2.604h2.134l.616-2.62L17.662 12Zm10.145 2.797-.365 1.55h-2.665l-.285 1.216h3.05l-.358 1.521h-5.045L23.804 12h5.088l-.415 1.763h-3.092l-.243 1.034h2.665Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M29.37 12.796h.103l.157.275h.102l-.17-.28c.087-.01.155-.06.155-.175 0-.125-.07-.18-.21-.18h-.228v.635h.09v-.275Zm0-.082v-.197h.123c.062 0 .13.014.13.094 0 .098-.07.103-.146.103h-.108Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M29.478 13.303a.531.531 0 0 0 .522-.55c0-.318-.24-.55-.522-.55a.533.533 0 0 0-.526.55c0 .318.241.55.526.55Zm-.422-.55c0-.262.185-.459.422-.459.234 0 .418.197.418.458 0 .265-.184.46-.418.46-.237 0-.422-.195-.422-.46Z',
      fill: '#fff',
    }),
  );
});
nyceSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var nyce = {
  category: 'brand',
  colorable: false,
  name: 'nyce',
  svg: nyceSvg,
};
